import { useEffect, useState } from "react";
import "../assets/styles/components/menu.scss";
import { NavLink } from "react-router-dom";
import Exit from "../assets/icons/exit";
import { deleteCookie, getCookie, setCookie } from "../utils/cookie";
import { permissions } from "../utils/permissions";
import CrownRounded from "../assets/icons/crown-rounded";

export default function Menu({ context, updateContext, closeMenu }) {
  const [close_menu_effect, setCloseMenuEffect] = useState("");
  const [is_impersonated, setIsImpersonated] = useState(false);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    let impersonate_pv = getCookie("pv_impersonate");
    if (impersonate_pv) setIsImpersonated(true);
  }, []);

  const handleCloseMenu = () => {
    setCloseMenuEffect("close-effect");
    setTimeout(() => {
      document.body.style.overflow = "auto";
      closeMenu();
    }, 500);
  };

  const handleStopImpersonated = () => {
    deleteCookie("pv_impersonate");
    window.location.reload();
  };

  return (
    <div
      onClick={() => handleCloseMenu()}
      className={`menu position-fixed w-100 h-100 py-4 d-flex justify-content-center align-items-center ${close_menu_effect}`}
    >
      <div className="menu__content shadow-lg position-fixed overflow-auto">
        {permissions.map((item, index) => {
          if (
            !!context &&
            !!context.session &&
            item.is_menu_area &&
            ((!context.is_active_directory &&
              (item.permission.includes("ALL") ||
                item.permission.includes(context.session.profileTypeCode))) ||
              (context.is_active_directory &&
                (item.permission_ad.includes("ALL") ||
                  item.permission_ad.includes(
                    context.session.profileTypeCode
                  )))) &&
            !item.exclude_to_menu_for.includes(context.session.profileTypeCode)
          ) {
            if (is_impersonated && item.impersonated_area_navigable) {
              return (
                <NavLink
                  to={item.href}
                  key={index}
                  className="d-flex align-items-center px-3"
                >
                  <span>{item.label}</span>
                  {item.icon}
                </NavLink>
              );
            } else if (!is_impersonated) {
              return (
                <NavLink
                  to={item.href}
                  key={index}
                  className="d-flex align-items-center px-3"
                >
                  <span>{item.label}</span>
                  {item.icon}
                </NavLink>
              );
            }
          }
        })}

        {is_impersonated ? (
          <>
            <hr className="my-1 mx-3" />
            <div
              className="d-flex align-items-center px-3"
              onClick={() => handleStopImpersonated()}
            >
              <span className="impersonated-text">Torna al tuo account</span>
              <CrownRounded size={24} color="#cc0c00" className="ms-auto" />
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
}
